import * as React from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { LandingPage } from "@/components/lp/LandingPage";
import { SignInModal } from "@/components/auth/SignInModal";
import { authPromise } from "@/lib/auth";

const PaymentStep = dynamic(
  () => import("@/components/payment/PaymentStep").then((m) => ({ default: m.PaymentStep })),
  { ssr: false },
);

const PhoneVerificationStep = dynamic(
  () => import("@/components/phone-verification/PhoneVerification").then((m) => ({ default: m.PhoneVerification })),
  { ssr: false },
);

const ConfigureWorkspace = dynamic(
  () => import("@/components/workspace/ConfigureWorkspace").then((m) => ({ default: m.ConfigureWorkspace })),
  { ssr: false },
);

type Step = "landing" | "payment" | "phoneVerification" | "workspace";

const HomePage: React.FC = () => {
  const [step, setStep] = React.useState<Step>("landing");
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("google-login-result") === "1") {
      authPromise.then((auth) => {
        if (auth?.isLoggedIn()) {
          setStep("payment");
        }
      });
    }
  }, []);

  const handleCtaClick = () => {
    authPromise.then((auth) => {
      if (auth?.isLoggedIn()) {
        setStep("payment");
      } else {
        setIsModalOpen(true);
      }
    });
  };

  const handleAuthSuccess = () => {
    setIsModalOpen(false);
    setStep("payment");
  };

  return (
    <>
      <Head>
        <title>WhatsApp Reminders by Any.do - Never Forget a Task Again</title>
        <meta
          name="description"
          content="Get reminders directly in WhatsApp. No app switching, no forgotten tasks – just message and done."
        />
      </Head>

      {step === "landing" && (
        <>
          <LandingPage onCtaClick={handleCtaClick} />
          <SignInModal open={isModalOpen} onOpenChange={setIsModalOpen} onSuccess={handleAuthSuccess} />
        </>
      )}

      {step === "payment" && <PaymentStep onSuccess={() => setStep("phoneVerification")} />}

      {step === "phoneVerification" && <PhoneVerificationStep onSuccess={() => setStep("workspace")} />}

      {step === "workspace" && <ConfigureWorkspace />}
    </>
  );
};

export default HomePage;
